<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="w-full mb-6">
          <div class="w-full mb-6">
            <label class="vs-input--label">{{ $t("DiscountType") }}</label>
            <div class="w-full">
              <v-select
                label="name"
                name="discountType"
                @input="onDiscountValueSelected"
                :options="discountTypes"
                v-model="discountType"
                :reduce="(x) => x.name"
                ref="discountTypeSelection"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('discountType')"
                >{{ errors.first("discountType") }}</span
              >
            </div>
          </div>
          <div class="vx-col w-full">
            <label class="vs-select--label">
              {{ $t("ProductName") }}
            </label>
            <treeselect
              v-model="contractProduct"
              name="productId"
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadProducts"
              v-validate="'required'"
              :max-height="1000"
              @select="onProductSelected"
              ref="product"
            />
          </div>
        </div>
        <div class="w-full mb-6" v-if="discountType == 'جشنواره'">
          <label class="vs-select--label mt-1">{{ $t("FestivalName") }}</label>
          <v-select
            label="name"
            name="festivalName"
            :options="model.allFestivals"
            v-model="model.categoryId"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            @input="onFestivalSelected"
            ref="festivalSelection"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('festivalName')"
            >{{ errors.first("festivalName") }}</span
          >
        </div>
        <div class="w-full mb-6">
          <label class="vs-input--label">{{ $t("CalculationType") }}</label>
          <div class="w-full">
            <v-select
              label="name"
              name="calculationType"
              :options="productDiscountTypes"
              v-model="model.productDiscountType"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              ref="calculationTypeSelection"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('calculationType')"
              >{{ errors.first("calculationType") }}</span
            >
          </div>
        </div>
        <div class="w-full mb-6">
          <vs-input
            class="inputx mt-1"
            v-model="model.discountAmount"
            name="discountAmount"
            :label="$t('DiscountAmount')"
            v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('discountAmount')"
            >{{ errors.first("discountAmount") }}</span
          >
        </div>
        <div class="w-full mb-6">
          <label class="vs-select--label datepicker-lb">{{
            $t("FromDate")
          }}</label>
          <date-picker
            v-model="model.startClock"
            name="startClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('FromDate')"
            :clearable="true"
            v-validate="{ required: true }"
            :disabled="disableIfFestival"
          />
          <span class="text-danger text-sm" v-show="errors.has('startClock')">{{
            errors.first("startClock")
          }}</span>
        </div>
        <div class="w-full mb-6">
          <label class="vs-select--label datepicker-lb">{{
            $t("ToDate")
          }}</label>
          <date-picker
            v-model="model.expireClock"
            name="expireClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('ToDate')"
            :clearable="true"
            v-validate="{ required: true }"
            :disabled="disableIfFestival"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('expireClock')"
            >{{ errors.first("expireClock") }}</span
          >
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}

::v-deep .text-danger {
  top: 0;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    festivalName: {
      required: "لطفا نام جشنواره راانتخاب نمایید.",
    },
    discountType: {
      required: "لطفا نوع تخفیف را انتخاب نمایید.",
    },
    calculationType: {
      required: "لطفا نوع محاسبه را انتخاب نمایید.",
    },
    startClock: {
      required: "لطفا تاریخ شروع را وارد نمایید.",
    },
    expireClock: {
      required: "لطفا تاریخ پایان را وارد نمایید.",
    },
    discountAmount: {
      required: "لطفا مقدار تخفیف را وارد نمایید.",
      regex: "تنها مجاز به وارد کردن کارکترهای عددی می‌باشید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_Discounts_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      popupTitle: "",
      discountTypes: [
        { name: "پایه", id: 1 },
        { name: "روزانه", id: 2 },
        { name: "ساعتی", id: 3 },
        { name: "جشنواره", id: 4 },
      ],
      discountType: "",
      productDiscountTypes: [
        { name: "درصدی", id: 1 },
        { name: "مقداری", id: 2 },
      ],
      productId: "",
      contractId: this.$route.params.id,
      contractProduct: null,
      disableIfFestival: false,
      disabled: false,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      searchContractProducts: "sale/searchContractProducts",
      createRegularDiscount: "discount/createRegularDiscount",
      createFestivalDiscount: "discount/createFestivalDiscount",
      createScheduleDiscount: "discount/createScheduleDiscount",
      updateDiscount: "discount/update",
    }),
    loadProducts({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchContractProducts({
              id: this.contractId,
              name: searchQuery,
            }).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.productId,
                  label:
                    element.persianName +
                    " - " +
                    element.warrantyName +
                    " - " +
                    element.colorName,
                  name: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onProductSelected(data) {
      this.model.product = {
        productId: data.id,
        contractId: this.contractId,
      };
    },
    onDiscountValueSelected(value) {
      if (value == "ساعتی" || value == "روزانه") {
        if (value == "ساعتی") {
          this.model.scheduleType = 0;
        } else if (value == "روزانه") {
          this.model.scheduleType = 1;
        }
      } else {
        this.model.scheduleType = null;
      }
      if (value == "جشنواره") {
        this.disableIfFestival = true;
      } else {
        this.disableIfFestival = false;
        this.model.startClock = "";
        this.model.expireClock = "";
        this.$validator.reset();
      }
    },
    ///onFestivalSelected()
    onFestivalSelected(categoryId) {
      if (this.discountType == "جشنواره") {
        this.model.startClock = this.model.allFestivals.filter(
          (x) => x.id == categoryId
        )[0].startClock;
        this.model.expireClock = this.model.allFestivals.filter(
          (x) => x.id == categoryId
        )[0].expireClock;
      }
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          if (this.model.id == null) {
            if (this.model.scheduleType == null) {
              if (this.model.categoryId) {
                this.createFestivalDiscount(this.model).then(() => {
                  this.$swal({
                    position: "center-center",
                    type: "success",
                    text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                    showConfirmButton: false,
                    timer: 2000,
                  }).then(() => {
                    setTimeout(() => {
                      this.$emit("finish");
                      this.model = {};
                      this.$refs.discountTypeSelection.clearSelection();
                      this.$refs.calculationTypeSelection.clearSelection();
                      this.$refs.festivalSelection.clearSelection();
                      this.$refs.product.clear();
                      this.$validator.reset();
                    }, 0);
                  });
                });
                this.disabled = false;
              } else {
                this.createRegularDiscount(this.model).then(() => {
                  setTimeout(() => {
                    this.$emit("finish");
                    this.model = {};
                    this.$refs.discountTypeSelection.clearSelection();
                    this.$refs.calculationTypeSelection.clearSelection();
                    this.$refs.product.clear();
                    this.$validator.reset();
                  }, 3000);
                });
                this.disabled = false;
              }
            } else {
              this.createScheduleDiscount(this.model).then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                  setTimeout(() => {
                    this.$emit("finish");
                    this.model = {};
                    this.$refs.discountTypeSelection.clearSelection();
                    this.$refs.calculationTypeSelection.clearSelection();
                    this.$refs.product.clear();
                    this.$validator.reset();
                  }, 0);
                });
              });
              this.disabled = false;
            }
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) {
          this.popupTitle = "EditDiscount";
        } else {
          this.popupTitle = "AddNewDiscount";
        }
      }
      this.$validator.reset();
      this.disabled = false;
    },
  },
  components: {
    "v-select": vSelect,
    Treeselect,
  },
};
</script>
